<form autocomplete="off" [formGroup]="consumidorAlterarSenhaForm">

    <div class="row" *ngIf="!exibeInfoSeguranca">
        <div class="col-sm-6 offset-sm-3">

            <div class="card">
                
                <div class="card-header">
                    Recuperação de Senha Nota Premiada Bahia
                </div>                

                <div class="row" *ngIf="msgErroRecuperacaoSenha">
                    <div class="col-sm-12">
                      <div class="alert alert-danger" role="alert">
                        {{msgErroRecuperacaoSenha}}
                      </div>
                    </div>
                  </div>

                <div class="card-body" *ngIf="dadosConsumidorConfirmacao === null && !confirmarSenha">
                    <!-- row -->
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label for="cpf">CPF</label>
                                <input type="text" class="form-control" name="cpf" id="cpf" placeholder="Digite o seu CPF" formControlName="cpf" [textMask]="maskCPF">

                                <div *ngFor="let error of formErrors.cpf" class="alert alert-danger">
                                    {{ error }}
                                </div>
                            </div> 
                        </div>
                    </div>

                    <!--/.row-->          
                    <div class="row" *ngIf="this.useRecaptcha">
                        <div class="col-12 section-block small-text" style="font-size: 11px;">
                            <re-captcha (resolved)="resolved($event)" siteKey="{{ recaptcha }}"></re-captcha> <!-- LOCALHOST -->
                        </div>
                    </div>
                    <!--/.row-->       
                                 
                    <br>
                    <!-- row -->
                    <div class="row">
                        <div class="col-sm-12">
                            <button type="button" class="btn btn-bluelight" [disabled]="!validRecaptcha || !consumidorAlterarSenhaForm.get('cpf').valid" (click)="onProcurarCPF()"
                            data-toggle="tooltip" data-placement="top" title="Procurar">Procurar</button>
                        </div>
                    </div>

                </div>


                <div class="card-body" *ngIf="dadosConsumidorConfirmacao !== null && !confirmarSenha">

                    <!-- row -->
                    <div class="row" *ngIf="emailRecuperacaoEnviado">
                        <div class="col-sm-12">
                            <div class="alert alert-success" role="alert">
                                Uma mensagem foi enviada para &lt;{{mascaraEmailConfidencial(dadosConsumidorConfirmacao.emailPrincipal)}}&gt; com um link para você alterar sua senha de acesso ao site da Campanha NPB. Se não encontrar, verifique se está na sua caixa de Spam ou na Lixeira.
                            </div>                           
                        </div>
                    </div>

                    <!-- row -->
                    <div class="row" *ngIf="erroExibirDados">
                        <div class="col-sm-12">
                            <div class="alert alert-danger" role="alert">
                                {{msgExibirDados}}
                            </div>                           
                        </div>
                    </div>

                    <!-- row -->
                    <div class="row">
                        <div class="col-sm-12">
                            <dl class="row">
                                <dt class="col-sm-3">Nome</dt>
                                <dd class="col-sm-9">{{dadosConsumidorConfirmacao.nome}}</dd>
                                <dt class="col-sm-3">CPF</dt>
                                <dd class="col-sm-9">{{ cpfCompleto | cpfMask }}</dd>
                                <dt class="col-sm-3">E-mail</dt>
                                <dd class="col-sm-9">{{mascaraEmailConfidencial(dadosConsumidorConfirmacao.emailPrincipal)}}</dd>
                            </dl>
                        </div>
                    </div>

                    <!-- row -->
                    <div class="row" *ngIf="!emailRecuperacaoEnviado">
                        <div class="col-sm-12">
                            <button type="button" class="btn btn-bluelight" (click)="onGerarNovaSenha()">Quero gerar uma nova senha</button>
                            <button type="button" class="btn btn-default" (click)="onNaoEhMinhaConta()">Não é minha conta</button>
                        </div>
                    </div>

                    <div class="row" *ngIf="emailRecuperacaoEnviado">
                        <div class="col-sm-12 small">
                            Caso você não receba um e-mail em até 30 minutos, clique <a routerLink="/contato"><b>AQUI</b></a> para entrar em contato com a nossa equipe.                            
                        </div>
                    </div>

                </div>


                <div class="card-body" *ngIf="confirmarSenha">

                    <!-- row -->
                    <div class="row" *ngIf="senhaAlterada">
                        <div class="col-sm-12">
                            <div class="alert alert-success" role="alert">
                                Senha Alterada com sucesso! Sua senha foi alterada com sucesso.
                            </div>                           
                        </div>
                    </div>

                    <!-- row -->
                    <div class="row" *ngIf="erroSenhaAlterada">
                        <div class="col-sm-12">
                            <div class="alert alert-danger" role="alert">
                                {{msgSenhaAlteracao}}
                            </div>                           
                        </div>
                    </div>

                    <!-- row -->
                    <div class="row" *ngIf="!senhaAlterada">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label for="cpf">Nova Senha</label>
                                <input type="password" autocomplete="new-password" class="form-control" name="senha" id="senha" formControlName="senha" maxlength="30">

                                <div *ngFor="let error of formErrors.senha" class="alert alert-danger">
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- row -->
                    <div class="row" *ngIf="!senhaAlterada">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label for="cpf">Confirmar Nova Senha</label>
                                <input type="password" autocomplete="new-password" class="form-control" name="confirmarSenha" id="confirmarSenha" formControlName="confirmarSenha" maxlength="30">

                                <div *ngFor="let error of formErrors.confirmarSenha" class="alert alert-danger">
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- row -->
                    <div class="row" *ngIf="!senhaAlterada">
                        <div class="col-sm-12">
                            <button type="button" class="btn btn-bluelight"
                                (click)="onAlterarSenha()"
                                [disabled]="!consumidorAlterarSenhaForm.get('senha').valid || !consumidorAlterarSenhaForm.get('confirmarSenha').valid">
                                Alterar Senha
                            </button> &nbsp;
                            <button type="button" class="btn btn-danger" (click)="cancelaAlterarSenha()"
                                    data-toggle="tooltip" data-placement="top" title="Cancelar">
                              Cancelar
                            </button>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>

    <div class="row" *ngIf="exibeInfoSeguranca">
        <div class="col-12">
            <h3>   
                <b>Atualize suas informações de segurança</b>
            </h3>
        </div>
        <hr>
        <div class="col-12">
            <p> 
                Caso ocorra um problema com a sua conta, estas informações facilitarão o retorno ao seu cadastro da Nota Premiada Bahia:
            </p>
            <p> 
                Nome: <b>{{ dadosConsumidorConfirmacao.nome | uppercase }}</b>
                <br>
                CPF: <b>{{ dadosConsumidorConfirmacao.cpfBase + '' + dadosConsumidorConfirmacao.cpfDigito | cpfMask }}</b>
            </p>
            <h4>
                <b> E-mails de Contato</b>
            </h4>
            <p>
                Sempre cadastre os e-mails de contato adicionais. Isto protege a sua conta, caso não tenha mais acesso ao seu endereço de e-mail principal.
            </p>
            <h4>
                <b> Frase de Segurança</b>
            </h4>
            <p>
                Cadastre uma frase de segurança (texto de sua escolha) que você a reconheça ao ler. Esta frase aparecerá em todas
                as mensagens enviadas pela Campanha Nota Premiada Bahia para os seus e-mails, de modo que você tenha segurança da 
                autenticidade do remetente. Sempre que receber um e-mail da Campanha Nota Premiada Bahia, confira a frase de 
                segurança informada na mensagem. Caso ela não exista ou esteja incorreta, não abra a mensagem e proceda a 
                sua exclusão.
            </p>
            
        </div>
        <div class="col-12">
            <button class="btn btn-bluelight" routerLink="/consumidor/detalhar">
                Ir para meu cadastro
            </button>
        </div>
    </div>
</form>



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-alterar-senha/consumidor-alterar-senha.component.html